import InvestorGrievances from "../assets/pdf/Investor-grievances.docx.pdf";
import VigilMechanismPolicy from "../assets/pdf/VigilMechanismPolicy.pdf";
import PolicyonRelatedPartyTransactionExempted from "../assets/pdf/PolicyonRelatedPartyTransactionExempted.pdf";
import PolicyforDeterminationofMateriality from "../assets/pdf/PolicyforDeterminationofMateriality.pdf";
import PoliciesonPaymentstoNonExecutiveDirectors from "../assets/pdf/PoliciesonPaymentstoNonExecutiveDirectors.pdf";
import NRCPolicy from "../assets/pdf/NRCPolicy.pdf";
import FamilarisationProgrammeExempted from "../assets/pdf/FamilarisationProgrammeExempted.pdf";
import DividendDistributionPolicyExempted from "../assets/pdf/DividendDistributionPolicyExempted.pdf";
import CSRPolicy from "../assets/pdf/CSRPolicy.pdf";
import CodeOfPracticesAndProceduresForFaiDisclosureOfUnpublishedPriceSensitiveInformation from "../assets/pdf/CodeOfPracticesAndProceduresForFaiDisclosureOfUnpublishedPriceSensitiveInformation.pdf";
import COCforDirKMPExempted from "../assets/pdf/COCforDirKMPExempted.pdf";
import VariousCommiteeForBoard from "../assets/pdf/VariousCommiteeForBoard.pdf";
import DraftRedHerringProspectus from "../assets/pdf/DraftRedHerringProspectus.pdf";
import PRMedia from "../assets/pdf/PRMedia.pdf";
import PoshPolicy from "../assets/pdf/PoshPolicy.pdf";
import CommitteePoshPolicy from "../assets/pdf/CommitteePoshPolicy.pdf";

import BoardDiversityPolicy from "../assets/pdf/board-diversity-policy.pdf";
import BriefProfileOfBoardOfDirectorsIncludingDirectorship from "../assets/pdf/brief-profile-of-board-of-directors-including-directorship.pdf";
import CodeOfConductForPreventionOfInsiderTrading from "../assets/pdf/code-of-conduct-for-prevention-of-insider-trading.pdf";
import CodeOfConductIndependentDirector from "../assets/pdf/code-of-conduct-independent-director.pdf";
import CodeOfConductOfEmployee from "../assets/pdf/code-of-conduct-of-employee.pdf";
import LeakOfUPSI from "../assets/pdf/leak-of-UPSI.pdf";
import PolicyForDeterminingMaterialSubsidiary from "../assets/pdf/policy-for-determining-material-subsidiary.pdf";
import PolicyOfPreservationOfDocuments from "../assets/pdf/policy-of-preservation-of-documents.pdf";
import TermConditionOfAppointmentOfID from "../assets/pdf/term-condition-of-appointment-of-ID.pdf";
import WebsiteContentArchivalPolicy from "../assets/pdf/website-content-archival-policy.pdf";

const Pdf = {
  BoardDiversityPolicy,
  BriefProfileOfBoardOfDirectorsIncludingDirectorship,
  CodeOfConductForPreventionOfInsiderTrading,
  CodeOfConductIndependentDirector,
  CodeOfConductOfEmployee,
  PolicyForDeterminingMaterialSubsidiary,
  LeakOfUPSI,
  PolicyOfPreservationOfDocuments,
  TermConditionOfAppointmentOfID,
  WebsiteContentArchivalPolicy,
  InvestorGrievances,
  VigilMechanismPolicy,
  PolicyonRelatedPartyTransactionExempted,
  PolicyforDeterminationofMateriality,
  PoliciesonPaymentstoNonExecutiveDirectors,
  NRCPolicy,
  FamilarisationProgrammeExempted,
  DividendDistributionPolicyExempted,
  CSRPolicy,
  CodeOfPracticesAndProceduresForFaiDisclosureOfUnpublishedPriceSensitiveInformation,
  COCforDirKMPExempted,
  VariousCommiteeForBoard,
  DraftRedHerringProspectus,
  PRMedia,
  PoshPolicy,
  CommitteePoshPolicy,
};

export default Pdf;
